import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

type ComputeStrategyTagSize = "small" | "middle" | "large";

function ComputeStrategyTag({
  label,
  hintText,
  size = "middle"
}: Readonly<{
  label: string;
  hintText?: string;
  size?: ComputeStrategyTagSize;
}>) {
  let sizeClasses: string;

  switch (size) {
    case "small":
      sizeClasses = "px-2 py-0.5 text-xs";
      break;
    case "large":
      sizeClasses = "px-3 py-1 text-sm";
      break;
    case "middle":
    default:
      sizeClasses = "px-3 py-1 text-xs";
      break;
  }

  return (
    <div
      className={`inline-flex items-center gap-1.5 rounded-md border border-solid border-[var(--ciq-border-light)] !bg-[var(--ciq-gray-50)] !font-normal ${sizeClasses}`}
    >
      <span>{label}</span>
      {hintText && (
        <Tooltip title={hintText}>
          <InfoCircleOutlined
            className="text-ciq-gray-700 cursor-help"
            data-testid="compute-strategy-tag-info"
          />
        </Tooltip>
      )}
    </div>
  );
}

export default ComputeStrategyTag;
